import React from 'react';
import classes from './ListStatus.module.css';

/**
 * Footer for an infinitely scrolled list: carries the IntersectionObserver
 * sentinel and shows the loading / error / end-of-list state.
 *
 * Render it directly after the list, and pass the `sentinelRef` returned by
 * useInfiniteList.
 */
function ListStatus({
  sentinelRef,
  loading,
  loadingMore,
  error,
  hasMore,
  isEmpty,
  onRetry,
  emptyLabel = 'Nothing to show yet.',
  endLabel = "You've reached the end.",
}) {
  return (
    <div className={classes.status} ref={sentinelRef}>
      {(loading || loadingMore) && (
        <div className={classes.spinner} role="status" aria-label="Loading" />
      )}

      {!loading && !loadingMore && error && (
        <div className={classes.error}>
          <p>{error}</p>
          {onRetry && (
            <button type="button" onClick={onRetry}>
              Try again
            </button>
          )}
        </div>
      )}

      {!loading && !loadingMore && !error && isEmpty && (
        <p className={classes.message}>{emptyLabel}</p>
      )}

      {!loading && !loadingMore && !error && !isEmpty && !hasMore && (
        <p className={classes.message}>{endLabel}</p>
      )}
    </div>
  );
}

export default ListStatus;
